import * as React from "react";

const IconStarFilled: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="currentColor"><polygon fill="currentColor" points="6.309 20 8.337 23.844 12.619 24.584 9.588 27.699 10.207 32 6.309 30.083 2.409 32 3.028 27.699 0 24.584 4.28 23.844"  transform="translate(.443 -19.5)"/></svg>;
};

export default React.memo(IconStarFilled);
